if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      refreshCartContent() {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#CartDrawer'); document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;
        });
        fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((responseText) => {
          const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
        });
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);

            fetch('/cart.js', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json(); 
            })
            .then(cartData => {

              console.log(cartData.total_price);

              const priceThreshold = 9000;
              if (cartData.total_price < priceThreshold) {
                  const itemsToRemove = [];
                  cartData.items.forEach(item => {
                      if (item.properties && item.properties.upsell_offer) {
                          itemsToRemove.push(item.id); 
                      }
                  });
                  if (itemsToRemove.length > 0) {
                      let updates_rmv = {};
                      itemsToRemove.forEach(id => {
                          updates_rmv[id] = 0;
                      });
                      fetch(window.Shopify.routes.root + 'cart/update.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ updates: updates_rmv }) 
                      })
                      .then(response => {
                          if (!response.ok) {
                              return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                          }
                          return response.json();
                      })
                      .then((responseText) => {
                          this.refreshCartContent();
                      })
                      .catch(error => {
                          console.error("Error during upsell item removal:", error);
                      });
                  }
              }
              if( cartData.total_price < 7000 ){
              
                  const itemsToRemoveRs = [];
                  cartData.items.forEach(item => {
                      if (item.properties && item.properties.upsell_offer_rs) {
                          itemsToRemoveRs.push(item.id); 
                      }
                  });
                  if (itemsToRemoveRs.length > 0) {
                      let updates_rmvrs = {};
                      itemsToRemoveRs.forEach(id => {
                          updates_rmvrs[id] = 0;
                      });
                      fetch(window.Shopify.routes.root + 'cart/update.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ updates: updates_rmvrs }) 
                      })
                      .then(response => {
                          if (!response.ok) {
                              return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                          }
                          return response.json();
                      })
                      .then((responseText) => {
                          this.refreshCartContent();
                      })
                      .catch(error => {
                          console.error("Error during upsell item removal:", error);
                      });
                  }

              }

              // if( cartData.total_price >= 7000 ){
              
              //     const itemsToRemoveRschk = [];
              //     cartData.items.forEach(item => {
              //         if (item.properties && item.properties.upsell_offer_rs) {
              //             itemsToRemoveRschk.push(item.id); 
              //         }
              //     });
              //     console.log(itemsToRemoveRschk);
              //     if (itemsToRemoveRschk.length == 0) {
              //         let u_idrs = 55238358499701;
              //         let u_updateProductrs = {'items': [{'id': u_idrs,'quantity': 1,'properties': {'upsell_offer_rs': 'true'} }]};              
              //         fetch(window.Shopify.routes.root + 'cart/add.js', {
              //             method: 'POST',
              //             headers: {'Content-Type': 'application/json'},
              //             body: JSON.stringify(u_updateProductrs)
              //         }).then((response) => response.text())
              //         .then((responseText) => {
              //             this.refreshCartContent();
              //         }).finally(() =>{  }).catch((e) => { console.error(e); });          
              //     }

              // }


            })
            .catch(error => {
                console.error("There was a problem with the cart fetch operation:", error);
            });

          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
